// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"f41fe152","345":"46e53e5c"}[chunkId] + ".chunk.js";
};